import { useContext } from 'react'
import { StrategyOverviewCardsContext } from '../context/StrategyOverviewCardsContext'

export const useStrategyOverviewCards = () => {
  const context = useContext(StrategyOverviewCardsContext)

  if (!context) {
    throw new Error(
      `useStrategyOverviewCards must be used within a StrategyOverviewCardsProvider`
    )
  }

  return context
}
